import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  isDevMode,
  NgZone,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingService } from './services/loading/loading.service';
import { FaviconService } from './services/favicon/favicon.service';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';
import { LoginGrupoCliente, TrocarEmpresaRequest } from 'src/models/interfaces/login/login-interface';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { LoginCommonService } from './services/common/login-common.service';
import { LoginService } from './services/login/login.service';
import { MatSelect } from '@angular/material/select';
import { trigger, transition, style, animate } from '@angular/animations';
import { SvgIconService } from './services/icons/svg-icon.service';
import { MatSidenav } from '@angular/material/sidenav';
import { ThemeLoaderService } from './services/theme-loader/theme-loader.service';
import { HomeService } from './services/home/home.service';
import { BotAjudaCaixaService } from './services/bot-ajuda-caixa/bot-ajuda-caixa.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChatComponent } from './shared/components/chat/chat.component';
import { AccessService } from './services/common/access-common.service';
import { scheduleAppRefresh } from './shared/utils/refresh-view';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'spe-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('fadeBackdrop', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms ease-out', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0 }))])
    ])
  ],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  private _snackBar = inject(MatSnackBar);
  public isLoginPage = true;
  public isFuncionarioEditPage = false;
  public hideHeader = true;
  public loading$?: Observable<boolean>;
  title = 'vb-frontend';
  isCaixaFederalLogin: boolean = false;
  public mainHeaderCaixa = false;
  public sigla = localStorage.getItem('sigla');
  public isCaixa = localStorage.getItem('BRAND-THEME') == 'cef';
  private caixaChatbotLoaded = false;

  // ANTIGO ~NAVIGATION~
  companyName = '';
  companyCNPJ = '';
  clienteId: string = localStorage.getItem('idCliente')!;
  // TODO: remover essa logica temporaria

  login = localStorage.getItem('login')!;
  idPartner = localStorage.getItem('idParceria');
  cpfCnpj = localStorage.getItem('cnpj');
  private dialogReference?: MatDialogRef<ConfirmDialogComponent, any>;
  showSelect: boolean = false;
  grupoCliente: LoginGrupoCliente[] = [];
  grupoAtual?: LoginGrupoCliente;
  flagAlterarSenha: string = '';
  hideAlterarSenha: boolean = false;
  public hideAjuda = false;
  public autoComplete = new FormControl('');
  public options: string[] = [];
  public filteredOptions: Observable<string[]> | undefined;
  public screenWidth!: number;
  public screenHeight!: number;
  public showSearchBar = false;
  public drawerOpened: boolean = false;
  public showBackdrop: boolean = false;
  selectedOption!: string;

  @ViewChild('createDialogTemplate') createDialogTemplate: TemplateRef<any> | undefined;
  @ViewChild('select') select!: MatSelect;

  public constructor(
    public readonly themeService: ThemeService,
    private router: Router,
    public readonly loadingService: LoadingService,
    private favIconService: FaviconService,
    // ANTIGO ~NAVIGATION~
    private loginService: LoginService,
    private readonly dialog: MatDialog,
    public readonly loginCommonService: LoginCommonService,
    // CLOSE SEARCH BAR
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private themeLoaderService: ThemeLoaderService,
    public homeService: HomeService,
    private botAjudaCaixaService: BotAjudaCaixaService,
    public accessService: AccessService,
    private ngZone: NgZone,
    private appRef: ApplicationRef
  ) {
    if (isDevMode()) {
      const zoneName = this.ngZone.constructor?.name ?? '';
      if (zoneName.includes('Noop')) {
        console.error('[CD] NgZone is NoopNgZone — Zone change detection is NOT active.');
      } else {
        console.info('[CD] NgZone active:', zoneName);
      }
    }

    this.renderer.listen('window', 'click', (e: Event) => {
      const target = e.target as HTMLElement;

      const clickedInsideWrapper = target.closest('.ts-click');

      if (!clickedInsideWrapper) {
        this.showSearchBar = false;
        this.changeDetectorRef.detectChanges();
      }
    });

    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      scheduleAppRefresh(this.appRef, this.ngZone);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleRoute(event.urlAfterRedirects);
      }
    });
  }

  // private handleStorageChange = (event: StorageEvent) => {
  //   if (event.key === 'sigla') {
  //     // Handle sigla change
  //     console.log('Sigla changed:', event.newValue);
  //     this.themeLoaderService.initTheme();
  //   }
  // };

  public openChatbot() {
    const snackBar = this._snackBar.openFromComponent(ChatComponent, {
      panelClass: ['custom-snackbar'],
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      data: {
        close: () => {
          snackBar.dismiss();
        }
      }
    });
  }

  public FAB() {
    let left = screen.width / 2 - 400 / 2;
    let top = screen.height / 2 - 650 / 2;
    let idCliente = localStorage.getItem('idCliente');
    let idUsuario = localStorage.getItem('idUsuarioSiteSPE');

    if (idUsuario != '') {
      idUsuario = '&idUsuario=' + idUsuario;
    }

    window.open(
      'https://chat.vb.com.br/Chat/Start/9907f9f2bbd94bc3a6f8e517e8754da7?idCliente=' + idCliente + idUsuario,
      'Chat VB',
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=400, height=650, top=' +
        top +
        ', left=' +
        left
    );
  }

  /**
   * Inicializa o chatbot para clientes CAIXA
   */
  initializeCaixaChatbot(): void {
    try {
      this.botAjudaCaixaService.loadChatbot();
      console.log('Chatbot Caixa inicializado para cliente CAIXA');
    } catch (error) {
      console.error('Erro ao inicializar chatbot Caixa:', error);
    }
  }

  //Controle de estado do chabot
  private updateCaixaChatbot(): void {
    const shouldShow = this.isCaixa && !this.isLoginPage;
    if (shouldShow && !this.caixaChatbotLoaded) {
      this.initializeCaixaChatbot();
      this.caixaChatbotLoaded = true;
    } else if (!shouldShow && this.caixaChatbotLoaded) {
      this.botAjudaCaixaService.removeChatbot();
      this.caixaChatbotLoaded = false;
    }
  }

  ngOnInit() {
    this.loading$ = this.loadingService.loading$;
    // window.addEventListener('storage', this.handleStorageChange);
    this.loading$.subscribe(() => {
      this.changeDetectorRef.detectChanges();
    });
    setTimeout(() => {
      this.isCaixa = localStorage.getItem('BRAND-THEME') == 'cef';
    }, 100);

    this.updateCaixaChatbot();
    if (this.sigla == 'CAIXA') {
      this.mainHeaderCaixa = true;
    }

    this.verifyFavIcon();

    this.router.events.subscribe((d) => {
      const rotas = ['pdf-viewer', 'imprimir-boleto', 'demonstrativo'];
      for (const rota of rotas) {
        if (this.router.url.includes(rota)) {
          this.hideHeader = true;
          return;
        }
      }
    });

    // ANTIGO ~NAVIGATION~
    this.filteredOptions = this.autoComplete.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );

    this.getEmpresaData();
    this.companyCNPJ = localStorage.getItem('cnpj')!;
    this.companyName = localStorage.getItem('nomeEmpresa')!;
    this.flagAlterarSenha = localStorage.getItem('flagAlterarSenha') ?? '';
    this.verificaUsuarioSig();

    this.getScreenSize();
    // this.loadStyle('assets/custom.css');
    // if (this.sigla === 'CAIXA') {
    //   this.loadStyle('assets/custom-caixa.css');
    // }
  }

  // ngOnDestroy(): void {
  //   window.removeEventListener('storage', this.handleStorageChange);
  // }
  handleRoute(url: string) {
    if (url.includes('/home/funcionarios/editar')) {
      this.isFuncionarioEditPage = true;
    } else {
      this.isFuncionarioEditPage = false;
    }

    // Hide Ajuda button for pdf-viewer routes
    this.hideAjuda = url.includes('/pdf-viewer');

    if (url.includes('/resumo-itens-importados')) {
      this.hideHeader = true;
      this.mainHeaderCaixa = false;
      this.updateCaixaChatbot();
      return;
    }

    switch (url) {
      case '/login':
      case '/spe/login':
        this.isLoginPage = true;
        this.hideHeader = false;
        this.mainHeaderCaixa = false;
        break;
      case '/caixa/login':
        this.isLoginPage = true;
        this.isCaixaFederalLogin = true;
        this.hideHeader = false;
        this.mainHeaderCaixa = false;
        break;
      case '/login/logout':
      case '/login/timeout':
      case '/spe/login/logout':
      case '/caixa/login/logout':
        this.hideHeader = true;
        this.mainHeaderCaixa = false;
        break;
      case '/login/auth':
        this.hideHeader = true;
        break;

      default:
        this.isLoginPage = false;

        this.hideHeader = false;
        this.isCaixaFederalLogin = false;
        if (!this.homeService.menusCarregados) {
          this.homeService.getMenus();
        }
        break;
    }
    // Após determinar a rota, sincroniza o widget
    this.updateCaixaChatbot();
  }
  onDrawerStartOpen() {
    this.showBackdrop = true;
  }

  onDrawerOpened() {
    this.renderer.setStyle(document.documentElement, 'overflow', 'hidden');
  }

  onDrawerClosed() {
    this.renderer.removeStyle(document.documentElement, 'overflow');
  }

  onDrawerStartClose() {
    this.showBackdrop = false;
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();

    // Reveal app after Angular has rendered (prevents FOUC)
    const root = document.querySelector('spe-root');
    if (root) {
      root.classList.add('app-ready');
    }
  }

  openSelect() {
    this.select.open();
  }

  public imageClick = () => {
    this.router.navigate(['/home']);
  };

  openVeiculos() {
    window.open('https://www.sempararempresas.com.br/login', '_blank', 'noopener');
  }

  verifyFavIcon() {
    if (this.isCaixa) {
      this.favIconService.changeFavicon('assets/favicon/favicon2.png');
      this.favIconService.changeTitle('CAIXA');
    } else {
      this.favIconService.changeFavicon('assets/favicon/favicon1.png');
      this.favIconService.changeTitle('Sem Parar - Empresas');
    }
  }

  public manual = () => {
    const pdfURL = 'assets/Manual_Implantacao.pdf';
    window.open(pdfURL, '_blank');
  };

  public faleConosco = () => {
    this.router.navigate(['home/fale-conosco']);
  };

  // ANTIGO ~NAVIGATION~
  private _filter(value: string) {
    const filterValue = value.toLowerCase();
    return this.options.filter((option) => option.toLowerCase().includes(filterValue));
  }

  public click = (value: string) => {
    let cnpj = value.split('|||')[0];
    let company = this.grupoCliente.find((value) => {
      return value.cpfCnpj == cnpj;
    });
    if (company != undefined) {
      this.setCliente(company);
    }
  };

  public getCNPJString = (value: string) => {
    return value.split('|||')[0];
  };
  public getCompanyString = (value: string) => {
    return value.split('|||')[1];
  };

  verificaUsuarioSig() {
    const usuarioSig = localStorage.getItem('SIG');
    if (usuarioSig !== 'null') {
      this.hideAlterarSenha = true;
    }
  }

  getEmpresaData() {
    let grupo = JSON.parse(localStorage.getItem('grupoCliente')!);
    if (grupo && grupo.length > 1) {
      this.grupoCliente = grupo;
      this.grupoCliente.forEach((value) => {
        let string = `${value.cpfCnpj}|||${value.nomeRazaoSocial}`.replaceAll(/\s+/g, ' ');
        this.options.push(string);
      });
      this.showSelect = true;
      this.grupoAtual = this.grupoCliente.find((item) => {
        return item.cpfCnpj === localStorage.getItem('cnpj')!;
      });
      localStorage.setItem('idTipoCliente', this.grupoAtual?.idTipoClienteNegocio?.toString()!);
    }
  }

  public goTo = (path: string) => {
    if (path !== 'alterar-senha') {
      this.router.navigate([`home/${path}`]);
    } else {
      this.router.navigate([path]);
    }
  };

  public hide = () => {
    const rotas = ['resumo-itens-importados', 'imprimir-boleto'];
    const currentUrl = this.router.routerState.snapshot.url;
    return rotas.every((rota) => !currentUrl.includes(rota));
  };

  public logout = (sidenav?: MatSidenav) => () => {
    this.loginService.deslogar().subscribe({
      next: () => {
        this.loginService.removeLoginData();
        this.router.navigate(['login/logout']);
      },
      complete: () => {
        if (sidenav) {
          sidenav.close();
        }

        this.closeDialog();
      }
    });
  };

  public readonly openLogoutDialog = (sidenav?: MatSidenav) => {
    this.dialogReference = this.dialog.open(ConfirmDialogComponent, this.createDialog(sidenav));
  };

  createDialog = (sidenav?: MatSidenav): Object => {
    const data = {
      header: 'Logout',
      confirmAction: this.logout(sidenav),
      body: 'Deseja encerrar suas atividades?',
      icon: 'error',
      confirm: 'Sair'
    };

    return { data: data, autoFocus: false };
  };

  private readonly closeDialog = () => {
    if (this.dialogReference && this.dialogReference.getState() === MatDialogState.OPEN) {
      this.dialogReference.close();
    }
  };

  setCliente(value: LoginGrupoCliente) {
    const idParceria = localStorage.getItem('idParceria');
    this.showSearchBar = false;
    this.selectedOption = '';
    let body: TrocarEmpresaRequest = {
      idParceria: idParceria == '1' ? null : idParceria,
      cnpjCpf: value.cpfCnpj
    };

    if (this.validarEmail(localStorage.getItem('login')!)) body.email = localStorage.getItem('login')!;

    this.loginService.trocarEmpresa(body).subscribe({
      next: (data) => {
        localStorage.removeItem('menus');

        this.loginCommonService.setUserData(data, false, false);
        this.router.navigate(['home']).then(() => {
          window.location.reload();
        });
      }
    });
  }

  openPdf() {
    const pdfURL = 'assets/Manual_Implantacao.pdf';
    window.open(pdfURL, '_blank');
  }

  private validarEmail(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  @HostListener('window:resize')
  onResize() {
    this.getScreenSize();
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
}
